import React from "react";
import Slider from './Slider';
import About from './About';
import Services from './Services';
import SEO from './SEO';

const Home = () => {
	return (
		<div className='home'>
			<SEO
				title="Proteam Yönetim — Profesyonel Site & Apartman Yönetimi · İstanbul"
				description="Bütçe, teknik, güvenlik, temizlik, peyzaj ve hukuk hizmetleriyle site ve apartman yönetiminde 360° çözüm. İstanbul Küçükçekmece merkezli profesyonel ekip."
				path="/"
			/>
			<Slider />
			<About />
			<Services />
		</div>
	);
};

export default Home;

